// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMOrdersFragment-module__font-s-10___UYrgQ {
  font-size: 10px !important;
}

.CGMOrdersFragment-module__font-s-12___q9F2v {
  font-size: 12px !important;
}

.CGMOrdersFragment-module__font-s-13___HTvio {
  font-size: 13px !important;
}

.CGMOrdersFragment-module__font-s-14___Uhjrm {
  font-size: 14px !important;
}

.CGMOrdersFragment-module__font-s-15___jXolW {
  font-size: 15px !important;
}

.CGMOrdersFragment-module__font-s-16___h61Qc {
  font-size: 16px !important;
}

.CGMOrdersFragment-module__font-s-18___XA0Ui {
  font-size: 18px !important;
}

.CGMOrdersFragment-module__font-s-20___S1H6c {
  font-size: 20px !important;
}

.CGMOrdersFragment-module__font-s-22___M5LKY {
  font-size: 22px !important;
}

.CGMOrdersFragment-module__font-s-28___m7GM9 {
  font-size: 28px !important;
}

.CGMOrdersFragment-module__font-w-400___OELZ0 {
  font-weight: 400 !important;
}

.CGMOrdersFragment-module__font-w-500___aqb8j {
  font-weight: 500 !important;
}

.CGMOrdersFragment-module__font-w-600___uPfgz {
  font-weight: 600 !important;
}

.CGMOrdersFragment-module__font-w-700___uCJcC {
  font-weight: 700 !important;
}

.CGMOrdersFragment-module__p-5___fWEgU {
  padding: 5px !important;
}

.CGMOrdersFragment-module__p-12___bilsI {
  padding: 12px !important;
}

.CGMOrdersFragment-module__p-16___gNrq4 {
  padding: 16px !important;
}

.CGMOrdersFragment-module__p-30___fxQ8N {
  padding: 30px !important;
}

.CGMOrdersFragment-module__p-b-0___w5cRL {
  padding-bottom: 0 !important;
}

.CGMOrdersFragment-module__p-b-5___Eb6qB {
  padding-bottom: 5px !important;
}

.CGMOrdersFragment-module__p-b-10___JfcML {
  padding-bottom: 10px !important;
}

.CGMOrdersFragment-module__p-b-12___aBOL4 {
  padding-bottom: 12px !important;
}

.CGMOrdersFragment-module__p-b-16___K_sFN {
  padding-bottom: 16px !important;
}

.CGMOrdersFragment-module__p-b-18___x1lB4 {
  padding-bottom: 18px !important;
}

.CGMOrdersFragment-module__p-b-20___NuPOh {
  padding-bottom: 20px !important;
}

.CGMOrdersFragment-module__p-b-25___s4h9n {
  padding-bottom: 25px !important;
}

.CGMOrdersFragment-module__p-b-30___nN7LE {
  padding-bottom: 30px !important;
}

.CGMOrdersFragment-module__p-b-50___cUxCq {
  padding-bottom: 50px !important;
}

.CGMOrdersFragment-module__p-t-0___D9ldV {
  padding-top: 0 !important;
}

.CGMOrdersFragment-module__p-t-12___ou5nu {
  padding-top: 12px !important;
}

.CGMOrdersFragment-module__p-t-16___veJMq {
  padding-top: 16px !important;
}

.CGMOrdersFragment-module__p-t-18___hSV2H {
  padding-top: 18px !important;
}

.CGMOrdersFragment-module__p-t-20___xZkfR {
  padding-top: 20px !important;
}

.CGMOrdersFragment-module__p-t-30___le0hR {
  padding-top: 30px !important;
}

.CGMOrdersFragment-module__p-t-40___ZGmxz {
  padding-top: 40px !important;
}

.CGMOrdersFragment-module__p-t-50___nQu3W {
  padding-top: 50px !important;
}

.CGMOrdersFragment-module__p-l-20___Tumib {
  padding-left: 20px !important;
}

.CGMOrdersFragment-module__p-l-30___Mo7Ec {
  padding-left: 30px !important;
}

.CGMOrdersFragment-module__p-l-40___Jbuso {
  padding-left: 40px !important;
}

.CGMOrdersFragment-module__p-r-16___LyyrZ {
  padding-right: 16px !important;
}

.CGMOrdersFragment-module__p-r-20___cbMgs {
  padding-right: 20px !important;
}

.CGMOrdersFragment-module__p-r-30___WYkXZ {
  padding-right: 30px !important;
}

.CGMOrdersFragment-module__p-r-50___LgmMn {
  padding-right: 50px !important;
}

.CGMOrdersFragment-module__p-r-60___zvM2q {
  padding-right: 60px !important;
}

.CGMOrdersFragment-module__m-b-1___q71YM {
  margin-bottom: 1px !important;
}

.CGMOrdersFragment-module__m-b-2___Z_y03 {
  margin-bottom: 2px !important;
}

.CGMOrdersFragment-module__m-b-6___FyS0R {
  margin-bottom: 6px !important;
}

.CGMOrdersFragment-module__m-b-8___Gy5rw {
  margin-bottom: 8px !important;
}

.CGMOrdersFragment-module__m-b-10___sIONf {
  margin-bottom: 10px !important;
}

.CGMOrdersFragment-module__m-b-14___M32cK {
  margin-bottom: 14px !important;
}

.CGMOrdersFragment-module__m-b-16___jbk3i {
  margin-bottom: 16px !important;
}

.CGMOrdersFragment-module__m-b-20___ucq3i {
  margin-bottom: 20px !important;
}

.CGMOrdersFragment-module__m-b-22___HO9Bv {
  margin-bottom: 22px !important;
}

.CGMOrdersFragment-module__m-b-24___KuliF {
  margin-bottom: 24px !important;
}

.CGMOrdersFragment-module__m-b-30___WbmcR {
  margin-bottom: 30px !important;
}

.CGMOrdersFragment-module__m-b-32___bFOKm {
  margin-bottom: 32px !important;
}

.CGMOrdersFragment-module__m-b-40___VyvtA {
  margin-bottom: 40px !important;
}

.CGMOrdersFragment-module__m-t-2___OpdJk {
  margin-top: 2px !important;
}

.CGMOrdersFragment-module__m-t-3___dztYS {
  margin-top: 3px !important;
}

.CGMOrdersFragment-module__m-t-4___eBqul {
  margin-top: 4px !important;
}

.CGMOrdersFragment-module__m-t-5___F_tcS {
  margin-top: 5px !important;
}

.CGMOrdersFragment-module__m-t-8___rWyCX {
  margin-top: 8px !important;
}

.CGMOrdersFragment-module__m-t-10___GbPfS {
  margin-top: 10px !important;
}

.CGMOrdersFragment-module__m-t-15___q0npi {
  margin-top: 15px !important;
}

.CGMOrdersFragment-module__m-t-16___HssJf {
  margin-top: 16px !important;
}

.CGMOrdersFragment-module__m-t-20___R7GIY {
  margin-top: 20px !important;
}

.CGMOrdersFragment-module__m-t-22___BTUkd {
  margin-top: 22px !important;
}

.CGMOrdersFragment-module__m-t-30___vctnd {
  margin-top: 30px !important;
}

.CGMOrdersFragment-module__m-t-32___PfsAo {
  margin-top: 32px !important;
}

.CGMOrdersFragment-module__m-l-auto___LoVFL {
  margin-left: auto !important;
}

.CGMOrdersFragment-module__m-l-4___yUllg {
  margin-left: 4px !important;
}

.CGMOrdersFragment-module__m-l-5___dH5Gc {
  margin-left: 5px !important;
}

.CGMOrdersFragment-module__m-l-6___gyNZD {
  margin-left: 6px !important;
}

.CGMOrdersFragment-module__m-l-8___zXAIB {
  margin-left: 8px !important;
}

.CGMOrdersFragment-module__m-l-10___elFvW {
  margin-left: 10px !important;
}

.CGMOrdersFragment-module__m-l-16___ykFms {
  margin-left: 16px !important;
}

.CGMOrdersFragment-module__m-l-20___vBzkr {
  margin-left: 20px !important;
}

.CGMOrdersFragment-module__m-l-24___eT_Mq {
  margin-left: 24px !important;
}

.CGMOrdersFragment-module__m-l-30___MQDWz {
  margin-left: 30px !important;
}

.CGMOrdersFragment-module__m-l-35____duVg {
  margin-left: 35px !important;
}

.CGMOrdersFragment-module__m-l-40___Z4UDu {
  margin-left: 40px !important;
}

.CGMOrdersFragment-module__m-r-8___jCZFM {
  margin-right: 8px !important;
}

.CGMOrdersFragment-module__m-r-10___hXbHz {
  margin-right: 10px !important;
}

.CGMOrdersFragment-module__m-r-16___Ffehu {
  margin-right: 16px !important;
}

.CGMOrdersFragment-module__m-r-20___HFfru {
  margin-right: 20px !important;
}

.CGMOrdersFragment-module__m-r-24___BlaOQ {
  margin-right: 24px !important;
}

.CGMOrdersFragment-module__m-r-30___avGUt {
  margin-right: 30px !important;
}

.CGMOrdersFragment-module__m-r-40___w11iZ {
  margin-right: 40px !important;
}

.CGMOrdersFragment-module__border-r-3___iDrsR {
  border-radius: 3px !important;
}

.CGMOrdersFragment-module__border-r-4___xs6Cv {
  border-radius: 4px !important;
}

.CGMOrdersFragment-module__border-r-6___NNbeo {
  border-radius: 6px !important;
}

.CGMOrdersFragment-module__border-r-10___DBqVl {
  border-radius: 10px !important;
}

.CGMOrdersFragment-module__border-r-12___aY5z5 {
  border-radius: 12px !important;
}

.CGMOrdersFragment-module__border-r-16___LefLZ {
  border-radius: 16px !important;
}

.CGMOrdersFragment-module__border-r-50___MxK_P {
  border-radius: 50% !important;
}

.CGMOrdersFragment-module__primary-border___dZNBV {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMOrdersFragment-module__primary-border-b___xWNBv {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMOrdersFragment-module__primary-border-t___dfwwn {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMOrdersFragment-module__primary-border-l___BZQnd {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMOrdersFragment-module__primary-border-r___LheQ8 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMOrdersFragment-module__secondary-border___jL7sp {
  border: 1px solid #637768;
}

.CGMOrdersFragment-module__secondary-border-b___mylWH {
  border-bottom: 1px solid #637768;
}

.CGMOrdersFragment-module__secondary-border-t___lGUyI {
  border-top: 1px solid #637768;
}

.CGMOrdersFragment-module__secondary-border-l___kfuxD {
  border-left: 1px solid #637768;
}

.CGMOrdersFragment-module__secondary-border-r___u79JN {
  border-right: 1px solid #637768;
}

.CGMOrdersFragment-module__gap-0___ZLWr3 {
  gap: 0 !important;
}

.CGMOrdersFragment-module__gap-2___vxEFL {
  gap: 2px !important;
}

.CGMOrdersFragment-module__gap-4___rXKWp {
  gap: 4px !important;
}

.CGMOrdersFragment-module__gap-5___fro86 {
  gap: 5px !important;
}

.CGMOrdersFragment-module__gap-6___plYON {
  gap: 6px !important;
}

.CGMOrdersFragment-module__gap-8___GqQ9Z {
  gap: 8px !important;
}

.CGMOrdersFragment-module__gap-10___oA3N0 {
  gap: 10px !important;
}

.CGMOrdersFragment-module__gap-12___uAKAp {
  gap: 12px !important;
}

.CGMOrdersFragment-module__gap-14___rEVZ2 {
  gap: 14px !important;
}

.CGMOrdersFragment-module__gap-16___zzQeg {
  gap: 16px !important;
}

.CGMOrdersFragment-module__gap-18___d39UG {
  gap: 18px !important;
}

.CGMOrdersFragment-module__gap-20___IkWU2 {
  gap: 20px !important;
}

.CGMOrdersFragment-module__gap-24___fW10y {
  gap: 24px !important;
}

.CGMOrdersFragment-module__gap-26___xKb2Y {
  gap: 26px !important;
}

.CGMOrdersFragment-module__gap-30___H5bL2 {
  gap: 30px !important;
}

.CGMOrdersFragment-module__gap-32___ZG0bg {
  gap: 32px !important;
}

.CGMOrdersFragment-module__gap-40___r6WQG {
  gap: 40px !important;
}

.CGMOrdersFragment-module__gap-50___UTW6G {
  gap: 50px !important;
}

.CGMOrdersFragment-module__flex-1___kcs_o {
  flex: 1;
}

.CGMOrdersFragment-module__flex-none___YuLwA {
  flex: none !important;
}

.CGMOrdersFragment-module__flex-column___F5Wmq {
  display: flex;
  flex-direction: column !important;
}

.CGMOrdersFragment-module__flex-row___k3ICg {
  display: flex;
  flex-direction: row !important;
}

.CGMOrdersFragment-module__vertically-centered___ngoXp {
  display: flex;
  align-items: center !important;
}

.CGMOrdersFragment-module__horizontally-centered___aozRY {
  display: flex;
  justify-content: center !important;
}

.CGMOrdersFragment-module__horizontally-end___isA_y {
  display: flex;
  justify-content: end !important;
}

.CGMOrdersFragment-module__vertically-start___HhUCw {
  display: flex;
  align-items: start !important;
}

.CGMOrdersFragment-module__space-between___w_uNN {
  display: flex;
  justify-content: space-between !important;
}

.CGMOrdersFragment-module__flex-wrap___DT7Ai {
  flex-wrap: wrap !important;
}

.CGMOrdersFragment-module__height-100___NYdP1 {
  height: 100%;
}

.CGMOrdersFragment-module__width-50___Bhuod {
  width: 50% !important;
}

.CGMOrdersFragment-module__width-100___dwvZU {
  width: 100%;
}

.CGMOrdersFragment-module__cursor-pointer___a1lGJ {
  cursor: pointer;
}

.CGMOrdersFragment-module__cursor-not-allowed___NuxZT {
  cursor: not-allowed !important;
}

.CGMOrdersFragment-module__absolute-centered___AN3E8 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMOrdersFragment-module__absolute___KVC6v {
  position: absolute;
}

.CGMOrdersFragment-module__relative___bMGP7 {
  position: relative;
}

.CGMOrdersFragment-module__fixed___IiwXC {
  position: fixed;
}

.CGMOrdersFragment-module__visible___h7byM {
  opacity: 1;
}

.CGMOrdersFragment-module__invisible___SnDnR {
  opacity: 0;
}

.CGMOrdersFragment-module__col-90___P9W3V {
  width: 90% !important;
}

.CGMOrdersFragment-module__col-auto___JHSWl {
  width: auto !important;
}

.CGMOrdersFragment-module__medical-tabs___GKCT1 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMOrdersFragment-module__medical-table-new___Cig6x {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMOrdersFragment-module__medical-table-new___Cig6x:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMOrdersFragment-module__medical-table-new___Cig6x::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMOrdersFragment-module__medical-table-new___Cig6x::-webkit-scrollbar-track {
  display: none;
}
.CGMOrdersFragment-module__medical-table-new___Cig6x.CGMOrdersFragment-module__no-pagination___QKC9g {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMOrdersFragment-module__medical-table-new___Cig6x.CGMOrdersFragment-module__no-pagination___QKC9g:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMOrdersFragment-module__medical-table-new___Cig6x.CGMOrdersFragment-module__no-pagination___QKC9g::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMOrdersFragment-module__medical-table-new___Cig6x.CGMOrdersFragment-module__no-pagination___QKC9g::-webkit-scrollbar-track {
  display: none;
}

.CGMOrdersFragment-module__medical-table-empty___EEyud {
  padding: 14px 40px !important;
}

.CGMOrdersFragment-module__icon-btn___IFzIE {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMOrdersFragment-module__search-icon___TJgdb {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMOrdersFragment-module__disable-select___p8EEH {
  user-select: none;
}

.CGMOrdersFragment-module__break-word___DeCSF {
  word-break: break-word;
}

.CGMOrdersFragment-module__popup-clear-btn___U7jQ3 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMOrdersFragment-module__scroll-m-b-20___azJBM {
  scroll-margin-bottom: 20px;
}

.CGMOrdersFragment-module__container____H03d {
  height: 100%;
}
.CGMOrdersFragment-module__container____H03d .CGMOrdersFragment-module__scrollableContainer___iWhFd {
  height: calc(100vh - 280px - var(--top-navigation) - var(--patient-details-header));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMOrdersFragment-module__container____H03d .CGMOrdersFragment-module__scrollableContainer___iWhFd:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMOrdersFragment-module__container____H03d .CGMOrdersFragment-module__scrollableContainer___iWhFd::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMOrdersFragment-module__container____H03d .CGMOrdersFragment-module__scrollableContainer___iWhFd::-webkit-scrollbar-track {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/CGMOrdersFragment/CGMOrdersFragment.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;AA8pBF;AA5pBE;ECKA,mFDHI;ECIJ,kBAAA;EACA,kBAAA;AD0pBF;ACxpBE;EACE,oCAAA;EACA,mBAAA;AD0pBJ;ACvpBE;EACE,UAAA;EACA,6BAAA;ADypBJ;ACtpBE;EACE,aAAA;ADwpBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  height: 100%;\n\n  .scrollableContainer {\n    @include verticalScroll(\n      calc(100vh - 280px - var(--top-navigation) - var(--patient-details-header))\n    );\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMOrdersFragment-module__font-s-10___UYrgQ`,
	"fontS12": `CGMOrdersFragment-module__font-s-12___q9F2v`,
	"fontS13": `CGMOrdersFragment-module__font-s-13___HTvio`,
	"fontS14": `CGMOrdersFragment-module__font-s-14___Uhjrm`,
	"fontS15": `CGMOrdersFragment-module__font-s-15___jXolW`,
	"fontS16": `CGMOrdersFragment-module__font-s-16___h61Qc`,
	"fontS18": `CGMOrdersFragment-module__font-s-18___XA0Ui`,
	"fontS20": `CGMOrdersFragment-module__font-s-20___S1H6c`,
	"fontS22": `CGMOrdersFragment-module__font-s-22___M5LKY`,
	"fontS28": `CGMOrdersFragment-module__font-s-28___m7GM9`,
	"fontW400": `CGMOrdersFragment-module__font-w-400___OELZ0`,
	"fontW500": `CGMOrdersFragment-module__font-w-500___aqb8j`,
	"fontW600": `CGMOrdersFragment-module__font-w-600___uPfgz`,
	"fontW700": `CGMOrdersFragment-module__font-w-700___uCJcC`,
	"p5": `CGMOrdersFragment-module__p-5___fWEgU`,
	"p12": `CGMOrdersFragment-module__p-12___bilsI`,
	"p16": `CGMOrdersFragment-module__p-16___gNrq4`,
	"p30": `CGMOrdersFragment-module__p-30___fxQ8N`,
	"pB0": `CGMOrdersFragment-module__p-b-0___w5cRL`,
	"pB5": `CGMOrdersFragment-module__p-b-5___Eb6qB`,
	"pB10": `CGMOrdersFragment-module__p-b-10___JfcML`,
	"pB12": `CGMOrdersFragment-module__p-b-12___aBOL4`,
	"pB16": `CGMOrdersFragment-module__p-b-16___K_sFN`,
	"pB18": `CGMOrdersFragment-module__p-b-18___x1lB4`,
	"pB20": `CGMOrdersFragment-module__p-b-20___NuPOh`,
	"pB25": `CGMOrdersFragment-module__p-b-25___s4h9n`,
	"pB30": `CGMOrdersFragment-module__p-b-30___nN7LE`,
	"pB50": `CGMOrdersFragment-module__p-b-50___cUxCq`,
	"pT0": `CGMOrdersFragment-module__p-t-0___D9ldV`,
	"pT12": `CGMOrdersFragment-module__p-t-12___ou5nu`,
	"pT16": `CGMOrdersFragment-module__p-t-16___veJMq`,
	"pT18": `CGMOrdersFragment-module__p-t-18___hSV2H`,
	"pT20": `CGMOrdersFragment-module__p-t-20___xZkfR`,
	"pT30": `CGMOrdersFragment-module__p-t-30___le0hR`,
	"pT40": `CGMOrdersFragment-module__p-t-40___ZGmxz`,
	"pT50": `CGMOrdersFragment-module__p-t-50___nQu3W`,
	"pL20": `CGMOrdersFragment-module__p-l-20___Tumib`,
	"pL30": `CGMOrdersFragment-module__p-l-30___Mo7Ec`,
	"pL40": `CGMOrdersFragment-module__p-l-40___Jbuso`,
	"pR16": `CGMOrdersFragment-module__p-r-16___LyyrZ`,
	"pR20": `CGMOrdersFragment-module__p-r-20___cbMgs`,
	"pR30": `CGMOrdersFragment-module__p-r-30___WYkXZ`,
	"pR50": `CGMOrdersFragment-module__p-r-50___LgmMn`,
	"pR60": `CGMOrdersFragment-module__p-r-60___zvM2q`,
	"mB1": `CGMOrdersFragment-module__m-b-1___q71YM`,
	"mB2": `CGMOrdersFragment-module__m-b-2___Z_y03`,
	"mB6": `CGMOrdersFragment-module__m-b-6___FyS0R`,
	"mB8": `CGMOrdersFragment-module__m-b-8___Gy5rw`,
	"mB10": `CGMOrdersFragment-module__m-b-10___sIONf`,
	"mB14": `CGMOrdersFragment-module__m-b-14___M32cK`,
	"mB16": `CGMOrdersFragment-module__m-b-16___jbk3i`,
	"mB20": `CGMOrdersFragment-module__m-b-20___ucq3i`,
	"mB22": `CGMOrdersFragment-module__m-b-22___HO9Bv`,
	"mB24": `CGMOrdersFragment-module__m-b-24___KuliF`,
	"mB30": `CGMOrdersFragment-module__m-b-30___WbmcR`,
	"mB32": `CGMOrdersFragment-module__m-b-32___bFOKm`,
	"mB40": `CGMOrdersFragment-module__m-b-40___VyvtA`,
	"mT2": `CGMOrdersFragment-module__m-t-2___OpdJk`,
	"mT3": `CGMOrdersFragment-module__m-t-3___dztYS`,
	"mT4": `CGMOrdersFragment-module__m-t-4___eBqul`,
	"mT5": `CGMOrdersFragment-module__m-t-5___F_tcS`,
	"mT8": `CGMOrdersFragment-module__m-t-8___rWyCX`,
	"mT10": `CGMOrdersFragment-module__m-t-10___GbPfS`,
	"mT15": `CGMOrdersFragment-module__m-t-15___q0npi`,
	"mT16": `CGMOrdersFragment-module__m-t-16___HssJf`,
	"mT20": `CGMOrdersFragment-module__m-t-20___R7GIY`,
	"mT22": `CGMOrdersFragment-module__m-t-22___BTUkd`,
	"mT30": `CGMOrdersFragment-module__m-t-30___vctnd`,
	"mT32": `CGMOrdersFragment-module__m-t-32___PfsAo`,
	"mLAuto": `CGMOrdersFragment-module__m-l-auto___LoVFL`,
	"mL4": `CGMOrdersFragment-module__m-l-4___yUllg`,
	"mL5": `CGMOrdersFragment-module__m-l-5___dH5Gc`,
	"mL6": `CGMOrdersFragment-module__m-l-6___gyNZD`,
	"mL8": `CGMOrdersFragment-module__m-l-8___zXAIB`,
	"mL10": `CGMOrdersFragment-module__m-l-10___elFvW`,
	"mL16": `CGMOrdersFragment-module__m-l-16___ykFms`,
	"mL20": `CGMOrdersFragment-module__m-l-20___vBzkr`,
	"mL24": `CGMOrdersFragment-module__m-l-24___eT_Mq`,
	"mL30": `CGMOrdersFragment-module__m-l-30___MQDWz`,
	"mL35": `CGMOrdersFragment-module__m-l-35____duVg`,
	"mL40": `CGMOrdersFragment-module__m-l-40___Z4UDu`,
	"mR8": `CGMOrdersFragment-module__m-r-8___jCZFM`,
	"mR10": `CGMOrdersFragment-module__m-r-10___hXbHz`,
	"mR16": `CGMOrdersFragment-module__m-r-16___Ffehu`,
	"mR20": `CGMOrdersFragment-module__m-r-20___HFfru`,
	"mR24": `CGMOrdersFragment-module__m-r-24___BlaOQ`,
	"mR30": `CGMOrdersFragment-module__m-r-30___avGUt`,
	"mR40": `CGMOrdersFragment-module__m-r-40___w11iZ`,
	"borderR3": `CGMOrdersFragment-module__border-r-3___iDrsR`,
	"borderR4": `CGMOrdersFragment-module__border-r-4___xs6Cv`,
	"borderR6": `CGMOrdersFragment-module__border-r-6___NNbeo`,
	"borderR10": `CGMOrdersFragment-module__border-r-10___DBqVl`,
	"borderR12": `CGMOrdersFragment-module__border-r-12___aY5z5`,
	"borderR16": `CGMOrdersFragment-module__border-r-16___LefLZ`,
	"borderR50": `CGMOrdersFragment-module__border-r-50___MxK_P`,
	"primaryBorder": `CGMOrdersFragment-module__primary-border___dZNBV`,
	"primaryBorderB": `CGMOrdersFragment-module__primary-border-b___xWNBv`,
	"primaryBorderT": `CGMOrdersFragment-module__primary-border-t___dfwwn`,
	"primaryBorderL": `CGMOrdersFragment-module__primary-border-l___BZQnd`,
	"primaryBorderR": `CGMOrdersFragment-module__primary-border-r___LheQ8`,
	"secondaryBorder": `CGMOrdersFragment-module__secondary-border___jL7sp`,
	"secondaryBorderB": `CGMOrdersFragment-module__secondary-border-b___mylWH`,
	"secondaryBorderT": `CGMOrdersFragment-module__secondary-border-t___lGUyI`,
	"secondaryBorderL": `CGMOrdersFragment-module__secondary-border-l___kfuxD`,
	"secondaryBorderR": `CGMOrdersFragment-module__secondary-border-r___u79JN`,
	"gap0": `CGMOrdersFragment-module__gap-0___ZLWr3`,
	"gap2": `CGMOrdersFragment-module__gap-2___vxEFL`,
	"gap4": `CGMOrdersFragment-module__gap-4___rXKWp`,
	"gap5": `CGMOrdersFragment-module__gap-5___fro86`,
	"gap6": `CGMOrdersFragment-module__gap-6___plYON`,
	"gap8": `CGMOrdersFragment-module__gap-8___GqQ9Z`,
	"gap10": `CGMOrdersFragment-module__gap-10___oA3N0`,
	"gap12": `CGMOrdersFragment-module__gap-12___uAKAp`,
	"gap14": `CGMOrdersFragment-module__gap-14___rEVZ2`,
	"gap16": `CGMOrdersFragment-module__gap-16___zzQeg`,
	"gap18": `CGMOrdersFragment-module__gap-18___d39UG`,
	"gap20": `CGMOrdersFragment-module__gap-20___IkWU2`,
	"gap24": `CGMOrdersFragment-module__gap-24___fW10y`,
	"gap26": `CGMOrdersFragment-module__gap-26___xKb2Y`,
	"gap30": `CGMOrdersFragment-module__gap-30___H5bL2`,
	"gap32": `CGMOrdersFragment-module__gap-32___ZG0bg`,
	"gap40": `CGMOrdersFragment-module__gap-40___r6WQG`,
	"gap50": `CGMOrdersFragment-module__gap-50___UTW6G`,
	"flex1": `CGMOrdersFragment-module__flex-1___kcs_o`,
	"flexNone": `CGMOrdersFragment-module__flex-none___YuLwA`,
	"flexColumn": `CGMOrdersFragment-module__flex-column___F5Wmq`,
	"flexRow": `CGMOrdersFragment-module__flex-row___k3ICg`,
	"verticallyCentered": `CGMOrdersFragment-module__vertically-centered___ngoXp`,
	"horizontallyCentered": `CGMOrdersFragment-module__horizontally-centered___aozRY`,
	"horizontallyEnd": `CGMOrdersFragment-module__horizontally-end___isA_y`,
	"verticallyStart": `CGMOrdersFragment-module__vertically-start___HhUCw`,
	"spaceBetween": `CGMOrdersFragment-module__space-between___w_uNN`,
	"flexWrap": `CGMOrdersFragment-module__flex-wrap___DT7Ai`,
	"height100": `CGMOrdersFragment-module__height-100___NYdP1`,
	"width50": `CGMOrdersFragment-module__width-50___Bhuod`,
	"width100": `CGMOrdersFragment-module__width-100___dwvZU`,
	"cursorPointer": `CGMOrdersFragment-module__cursor-pointer___a1lGJ`,
	"cursorNotAllowed": `CGMOrdersFragment-module__cursor-not-allowed___NuxZT`,
	"absoluteCentered": `CGMOrdersFragment-module__absolute-centered___AN3E8`,
	"absolute": `CGMOrdersFragment-module__absolute___KVC6v`,
	"relative": `CGMOrdersFragment-module__relative___bMGP7`,
	"fixed": `CGMOrdersFragment-module__fixed___IiwXC`,
	"visible": `CGMOrdersFragment-module__visible___h7byM`,
	"invisible": `CGMOrdersFragment-module__invisible___SnDnR`,
	"col90": `CGMOrdersFragment-module__col-90___P9W3V`,
	"colAuto": `CGMOrdersFragment-module__col-auto___JHSWl`,
	"medicalTabs": `CGMOrdersFragment-module__medical-tabs___GKCT1`,
	"medicalTableNew": `CGMOrdersFragment-module__medical-table-new___Cig6x`,
	"noPagination": `CGMOrdersFragment-module__no-pagination___QKC9g`,
	"medicalTableEmpty": `CGMOrdersFragment-module__medical-table-empty___EEyud`,
	"iconBtn": `CGMOrdersFragment-module__icon-btn___IFzIE`,
	"searchIcon": `CGMOrdersFragment-module__search-icon___TJgdb`,
	"disableSelect": `CGMOrdersFragment-module__disable-select___p8EEH`,
	"breakWord": `CGMOrdersFragment-module__break-word___DeCSF`,
	"popupClearBtn": `CGMOrdersFragment-module__popup-clear-btn___U7jQ3`,
	"scrollMB20": `CGMOrdersFragment-module__scroll-m-b-20___azJBM`,
	"container": `CGMOrdersFragment-module__container____H03d`,
	"scrollableContainer": `CGMOrdersFragment-module__scrollableContainer___iWhFd`
};
module.exports = ___CSS_LOADER_EXPORT___;
